import { useEffect, useRef, useState, useCallback } from "react";
import api from "../api";
import EmailComposer from "./EmailComposer";

const KB = (n) => (n > 1048576 ? (n / 1048576).toFixed(1) + " MB" : Math.max(1, Math.round(n / 1024)) + " KB");
const dt = (iso) => { try { return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "2-digit" }); } catch { return ""; } };

export const LeadQuotes = ({ personId, leadEmail = "", leadName = "" }) => {
  const [docs, setDocs] = useState([]);
  const [busy, setBusy] = useState(false);
  const [followup, setFollowup] = useState(false);
  const inputRef = useRef(null);

  const load = useCallback(() => {
    api.get(`/documents?person_id=${personId}`).then((r) => setDocs(r.data)).catch(() => {});
  }, [personId]);
  useEffect(() => { load(); }, [load]);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        fd.append("person_id", personId);
        await api.post("/documents", fd, { headers: { "Content-Type": "multipart/form-data" } });
      }
      load();
    } catch (err) { alert("Errore: " + (err?.response?.data?.detail || err.message)); }
    setBusy(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  const download = async (d) => {
    try {
      const res = await api.get(`/documents/${d.id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = d.filename; a.click();
      URL.revokeObjectURL(url);
    } catch { alert("Errore nel download"); }
  };

  const remove = async (d) => {
    if (!window.confirm(`Eliminare "${d.filename}"?`)) return;
    try { await api.delete(`/documents/${d.id}`); load(); }
    catch (e) { alert("Errore: " + (e?.response?.data?.detail || e.message)); }
  };

  const followupBody = () => {
    const last = docs[0];
    const when = last ? ` in data ${dt(last.created_at)}` : "";
    return `<div>Gentile ${leadName || "cliente"},</div><div><br></div>` +
      `<div>le scrivo per sapere se ha avuto modo di valutare il preventivo che le abbiamo inviato${when}.</div>` +
      `<div>Resto a disposizione per qualsiasi chiarimento o per fissare un appuntamento, anche telefonico.</div><div><br></div>`;
  };

  return (
    <div className="panel" data-testid="lead-quotes-panel">
      <div className="toolbar">
        <h3 style={{ margin: 0 }}>📎 Preventivi e documenti inviati</h3>
        <span style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
          {docs.length > 0 && (
            <button className="btn sm" disabled={!leadEmail} title={leadEmail ? "Invia una email per chiedere se ha valutato il preventivo" : "Il lead non ha un'email"}
              onClick={() => setFollowup(true)} data-testid="lead-quote-followup-btn">📨 Chiedi se ha valutato</button>
          )}
          <input ref={inputRef} type="file" multiple style={{ display: "none" }} onChange={upload} data-testid="lead-quote-file-input" />
          <button className="btn primary sm" disabled={busy} onClick={() => inputRef.current?.click()} data-testid="lead-quote-upload-btn">
            {busy ? "Caricamento…" : "📎 Carica preventivo"}
          </button>
        </span>
      </div>
      {docs.length === 0 ? (
        <p className="muted" style={{ fontSize: 13 }}>Nessun preventivo caricato. Carica qui i PDF che hai inviato al lead, così restano nella sua scheda.</p>
      ) : (
        docs.map((d) => (
          <div key={d.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: "1px solid var(--border)", fontSize: 13 }} data-testid={`lead-quote-${d.id}`}>
            <span style={{ flex: 1 }}>📄 <b>{d.filename}</b> <span className="muted">· {dt(d.created_at)} · {KB(d.size)}</span></span>
            <button className="btn sm" onClick={() => download(d)} data-testid={`lead-quote-download-${d.id}`}>⬇ Scarica</button>
            <button className="btn sm danger" onClick={() => remove(d)} data-testid={`lead-quote-delete-${d.id}`}>🗑</button>
          </div>
        ))
      )}
      {followup && (
        <EmailComposer mode="new" prefillTo={leadEmail}
          prefillSubject="Ha avuto modo di valutare il nostro preventivo?"
          prefillBody={followupBody()}
          onClose={() => setFollowup(false)}
          onSent={() => setFollowup(false)} />
      )}
    </div>
  );
};
